import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {catchError, map, Observable, of} from "rxjs";

type TranslationDictionary = Record<string, unknown>;

@Injectable({
  providedIn: 'root',
})
export class CustomTranslateLoader {
  private httpClient: HttpClient = inject(HttpClient);

  constructor(
  ) {
  }

  getTranslation(lang: string): Observable<any> {
    return this.getLocalTranslations(lang).pipe(
      map((localTranslations: TranslationDictionary) => this.withFlatAliases(localTranslations))
    );
  }

  private getLocalTranslations(lang: string): Observable<TranslationDictionary> {
    return this.httpClient.get<TranslationDictionary>(`assets/i18n/${lang}.json`).pipe(
      catchError(() => this.httpClient.get<TranslationDictionary>('assets/i18n/de.json')),
      catchError((error: unknown) => {
        console.error('Could not load translations.', error);
        return of({});
      })
    );
  }

  private isTranslationDictionary(value: unknown): value is TranslationDictionary {
    return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
  }

  private withFlatAliases(translations: TranslationDictionary): TranslationDictionary {
    return {
      ...translations,
      ...this.flattenTranslations(translations),
    };
  }

  private flattenTranslations(
    translations: TranslationDictionary,
    prefix: string = '',
  ): TranslationDictionary {
    return Object.entries(translations).reduce<TranslationDictionary>((flattenedTranslations, [key, value]) => {
      const path = prefix ? `${prefix}.${key}` : key;

      if (this.isTranslationDictionary(value)) {
        return {
          ...flattenedTranslations,
          ...this.flattenTranslations(value, path),
        };
      }

      flattenedTranslations[path] = value;
      return flattenedTranslations;
    }, {});
  }
}
